import { render, staticRenderFns } from "./HighRiskUserProfilingDetails.vue?vue&type=template&id=6450b6e3"
import script from "./HighRiskUserProfilingDetails.vue?vue&type=script&lang=js"
export * from "./HighRiskUserProfilingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports